import React, {useEffect, useContext} from 'react'
import '../../styles/Reservation/Reservation.scss'
import './Reservation.scss'
import ReservationInitialize from '../ReservationInitialize'
import Navigation from './Navigation'
import Routes from './Routes'
import {Grid, IconButton, FormControlLabel, Checkbox} from '@material-ui/core'
import KeyboardArrowLeftRoundedIcon from '@material-ui/icons/KeyboardArrowLeftRounded'
import KeyboardArrowRightRoundedIcon from '@material-ui/icons/KeyboardArrowRightRounded'
import AddRoundedIcon from '@material-ui/icons/AddRounded'
import {useHistory} from 'react-router-dom'
import ReservationDialog from '../ReservationDialog'
import _ from 'lodash'
import Views from './Views'
import CalendarMain from './CalendarMain'
import DateStamps from './DateStamps'
import BarcodeToastMessage from '../BarcodeToastMessage'
import ShareableView from './ShareableView'

function ReservationMain({children}) {
  const [collapsePanel, setCollapsePanel] = React.useState(false)
  const [firstLoad, setFirstLoad] = React.useState(false)
  const history = useHistory()

  useEffect(() => {
    if (!firstLoad) {
      history.push({pathname: '/reservations/calendar'})
      setFirstLoad(true)
    }
  }, [firstLoad, history])

  const handleChange = () => {
    setCollapsePanel(prev => !prev)
  }

  const checkBoxChange = event => {
    //console.log(JSON.parse(event.currentTarget.value))
  }

  return (
    <ReservationInitialize>
      <ReservationDialog />
      <BarcodeToastMessage />
      <div className="reservation__wrapper c-res-mod">
        <div className="reservation__header-panel">
          <Navigation />
        </div>
        <div
          className={`reservation__body ${
            collapsePanel ? 'reservation__body--collapse-sidebar' : ''
          }`}
        >
          <div
            className={`reservation__left-section ${
              collapsePanel ? 'reservation__left-section--collapsed' : ''
            }`}
          >
            <CalendarMain />
            <div className="reservation__views-container ap-scrollbar">
              <Views />
              {/* <DateStamps /> */}
              <ShareableView />
            </div>
          </div>
          <div
            className={`reservation__main-container ${
              collapsePanel ? 'reservation__main-container--expanded' : ''
            } ${
              history.location.pathname === '/reservations/bookings'
                ? ''
                : 'reservation__main-padding'
            }`}
          >
            <div
              className="reservation__div-arrow"
              hidden={history.location.pathname === '/reservations/bookings'}
            >
              <IconButton
                onClick={handleChange}
                size="small"
                className="reservation__icon-button-arrow ap-icon-button ap-icon-button--sm"
              >
                {collapsePanel ? (
                  <KeyboardArrowRightRoundedIcon className="reservation__arrow-collapse" />
                ) : (
                  <KeyboardArrowLeftRoundedIcon className="reservation__arrow-collapse" />
                )}
              </IconButton>
            </div>
            <Routes />
          </div>
        </div>
      </div>
    </ReservationInitialize>
  )
}

export default ReservationMain
